<template>
    <app-container class="subscribe-page">
        <subscribe-header/>
        <div class="subscribe-page__content">
            <div class="subscribe-page__row">
                <input class="subscribe-page__input"
                       placeholder="输入昵称..."
                       v-model="nickName"
                />
            </div>
            <div class="subscribe-page__row">
                <input class="subscribe-page__input"
                       placeholder="输入邮箱..."
                       v-model="email"
                />
            </div>
            <div class="subscribe-page__row">
                <app-button class="subscribe-page__subscribe-button"
                            :disabled="submitButtonDisabled"
                            @click="handleSubscribeButtonClick"
                >
                    <app-loading v-if="loading"/>
                    <template v-else>
                        <app-icon value="icon-add"/>
                        订阅
                    </template>
                </app-button>
            </div>
            <div class="subscribe-page__row" v-if="errorMsg">
                <p class="subscribe-page__error-message">
                    {{errorMsg}}
                </p>
            </div>
        </div>
    </app-container>
</template>

<script>
    import AppContainer from '@components/AppContainer'
    import AppButton from '@components/AppButton'
    import AppIcon from '@components/AppIcon'
    import AppLoading from '@components/AppLoading'

    import SubscribeHeader from './components/Header'

    import subscribeService from '@service/subscribeService'

    export default {
        name: "Subscribe",
        data() {
            return {
                email: '',
                nickName: '',
                loading: false,
                errorMsg: ''
            }
        },
        computed: {
            submitButtonDisabled() {
                const {nickName, email, loading} = this

                return !loading && !this.validate(nickName, email)
            }
        },
        methods: {
            validate(nickName, email) {
                const regEmail = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
                return (regEmail.test(email) && nickName.trim())
            },
            handleSubscribeButtonClick() {
                const {submitButtonDisabled} = this
                if (!submitButtonDisabled) {
                    this.subscribe()
                }
            },
            async subscribe() {
                try {
                    this.loading = true
                    this.errorMsg = ''
                    const {nickName, email} = this
                    await subscribeService({
                        nickName,
                        email
                    })
                    this.errorMsg = '确认邮件已发送至您的邮箱，请注意查收。'
                } catch (e) {
                    const {message} = e
                    this.errorMsg = message
                } finally {
                    this.loading = false
                }
            }
        },
        components: {
            AppContainer,
            SubscribeHeader,
            AppButton,
            AppIcon,
            AppLoading
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .subscribe-page {
        padding: $paddingSP*2 $paddingMD $paddingSP;
        max-width: 800px;

        &__content {
            padding: $paddingSP;
            box-sizing: border-box;
            border-radius: $radius;
            background-color: $componentHighLightColor;
            background-color: var(--componentHighLightColor);
            @include transition-colors;
        }

        &__input {
            width: 100%;
            font-size: $fontSizeCommon;
            line-height: 1.7;
            padding: $paddingBase $paddingMD;
            font-weight: $fontWeightBolder;
            border-radius: $radius;
            color: $textColor;
            color: var(--textColor);
            background-color: $componentBackgroundColor;
            background-color: var(--componentBackgroundColor);

            outline: none;
            @include transition-colors;

            &::placeholder {
                opacity: .5;
            }
        }

        &__row {
            margin: 0 auto;

            max-width: 500px;

            &:not(:last-child) {
                margin-bottom: $paddingMD;
            }
        }

        &__subscribe-button {
            display: inline-block;
            width: 100%;
            text-align: center;
            padding: $paddingBase $paddingMD;
            border-radius: $radius;
            color: #fff;
            background-color: $darkPrimaryColor;
            @include transition-colors;


            .app-icon {
                font-weight: $fontWeightBolder;
                color: #fff;
                margin-right: $paddingSM;
            }


            &[disabled] {
                opacity: .3;
            }

            &:hover {
                color: #fff;
                background-color: $primaryColor;

                .app-icon {
                    color: #fff;
                }
            }
        }

        &__error-message {
            color: $primaryColor;
            color: var(--primaryColor);
            @include transition-colors;
        }

        .app-loading{
            padding: 0;
            height: 22px;
        }
    }
</style>